
<div class="gradient_teble_wrapper">
	<span i18n="@@dashboard.top_products" *ngIf="storeType === 'Products'">Top Products</span>
	<span i18n="@@dashboard.top_services" *ngIf="storeType === 'Services'">Top Services</span>
	<table class="top_table">
		<thead>
			<tr>
				<th style="width: 1%;">№</th>
				<th i18n="@@dashboard.products" *ngIf="storeType === 'Products'">Products</th>
				<th i18n="@@dashboard.services" *ngIf="storeType === 'Services'">Services</th>
				<th i18n="@@dashboard.sold">Sold</th>
				<th i18n="@@dashboard.total_earnings">Total Earnings</th>
			</tr>
		</thead>
		<tbody *ngIf="products.length > 0; else noProducts">
			<tr *ngFor="let product of products; let i = index">
				<td class="number">{{ i + 1 }}</td>
				<td>
					<div class="d-flex flex-column gap-1">
						{{ product.item_name }}
						<span class="product_price">{{ product.cost }}</span>
					</div>

				</td>
				<td>{{ product.total_qty }}</td>
				<td [innerHtml]="product.amount"></td>
			</tr>
		</tbody>
	</table>
	<ng-template #noProducts>
		<tbody>
			<tr>
				<td colspan="4" style="text-align: center; padding: 10px;" i18n="@@dashboard.no_products_found" *ngIf="storeType === 'Products'">No products found</td>
				<td colspan="4" style="text-align: center; padding: 10px;" i18n="@@dashboard.no_services_found" *ngIf="storeType === 'Services'">No services found</td>
			</tr>
		</tbody>
	</ng-template>
</div>
